<template>
  <div class="miniApp">
    
    <el-tabs v-model="activeName">
      <el-tab-pane label="小程序二维码" name="1" v-if="false">
        <div style="display: flex">
          <div class="app-view-top">
            <div class="app-view">
              <img src="../../../static/image/app.png" width="100%" height="auto" alt />
              <div
                v-for="(element, indexTop) in appView.pageWidgetRelationDTOList"
                :key="indexTop"
              >
                <!-- :class="indexTop==0?'menuBg':''" -->
                <div v-if="element.type == 'lbt'" style="position: relative">
                  <!-- :class="indexNowSty==indexTop?'line-dark':'line-dark-none1'" -->
                  <div
                    :style="element.list.length == 0 ? 'padding: 0px;' : 'padding: 10px;'"
                  >
                    <el-carousel height="150px" v-if="element.list.length > 0">
                      <el-carousel-item
                        v-for="(item, index) in element.list"
                        :key="index"
                      >
                        <!-- <a :href="item.url"> -->
                        <img :src="item.img" width="100%" height="100%" alt />
                        <!-- </a> -->
                      </el-carousel-item>
                    </el-carousel>
                    <div
                      height="150px"
                      v-else-if="element.list.length == 0"
                      class="view-none"
                    >
                      <div class="iconfont icon-lunbotu"></div>
                      <div>轮播图</div>
                    </div>
                  </div>
                </div>
                <div class="showe-elete" v-if="element.type == 'twdh'">
                  <div class="view-toolbar" v-if="element.list.length > 0">
                    <div
                      class="view-toolbar-item"
                      :style="'width:' + 25 + '%'"
                      v-for="(item, index) in element.list"
                      :key="index"
                    >
                      <img
                        :src="item.img"
                        width="60px"
                        height="60px"
                        style="border-radius: 30px"
                        alt
                      />
                      <div class="toolbar-item-text">{{ item.title }}</div>
                    </div>
                  </div>
                  <div
                    height="150px"
                    v-else-if="element.list.length == 0 && element.type == 'twdh'"
                    class="view-none"
                  >
                    <div class="iconfont icon-tuwendaohang"></div>
                    <div>图文导航</div>
                  </div>
                  <!-- <div class="chunk-showtext">图文导航</div> -->
                </div>
                <div class="showe-elete" v-if="element.type == 'spkc'">
                  <div class="view-operation" v-if="element.list.length > 0">
                    <div class="view-operation-text">{{ element.name }}</div>
                    <div class="view-operation-list">
                      <!-- <a :href="item.url" v-for="(item,index) in element.list" :key="index"> -->
                      <img
                        :src="item.img"
                        width="170"
                        height="100px"
                        v-for="(item, index) in element.list"
                        :key="index"
                        alt
                      />
                      <!-- </a> -->
                    </div>
                  </div>
                  <div
                    height="150px"
                    v-else-if="element.list.length == 0"
                    class="view-none"
                  >
                    <div class="iconfont icon-shangpinkecheng"></div>
                    <div>商品课程</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <el-card class="box-card" style="margin-left: 30px; width: 600px">
              <div slot="header" class="clearfix">
                <span
                  >店铺同步APP：<span style="font-weight: bold">{{
                    nowAppName
                  }}</span></span
                >
                <!-- <el-button style="float: right;" type="primary" size="mini">修改同步</el-button> -->
                <el-popover
                  placement="right"
                  width="400"
                  trigger="click"
                  v-model="appSelectVisible"
                >
                  <el-select size="small" placeholder="请选择" v-model="nowAppId">
                    <el-option
                      v-for="item in agentAppList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button type="primary" size="mini" @click="confirmChooseAPP"
                    >确定</el-button
                  >
                  <el-button
                    slot="reference"
                    style="float: right"
                    type="primary"
                    size="mini"
                    v-auth="'miniApp_/cardInfo/addOrUpdateCardInfo'"
                    >修改同步</el-button
                  >
                </el-popover>
              </div>
              <div class="text item">
                <div>小程序二维码</div>
                <div style="text-align: center; margin-top: 20px">
                  <div v-if="qrcode">
                    <img :src="qrcode" alt="" class="miniAppCodeImg" />
                  </div>
                  <div v-else class="miniAppCodeImg" @click="getMiniAppQrCode">
                    点击生成小程序推广码
                  </div>
                  <el-button
                    v-if="qrcode"
                    type="primary"
                    plain
                    size="mini"
                    @click="downloadCode"
                    style="margin-top: 30px"
                    >下载小程序码</el-button
                  >
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="名片设置" name="2">
        <div style="display: flex">
          <div
            class="container"
            style="
              min-width: 375px;
              min-width: 375px;
              height: 700px;
              overflow-y: scroll;
              background-color: #f2f5f8;
              margin-top: 20px;
            "
          >
            <div class="card" style="padding: 0">
              <div class="flex flexBetween flexCenter" style="padding: 10px">
                <div>
                  <div style="font-size: 26px; font-weight: bold">
                    {{ cardForm.name ? cardForm.name : "姓名" }}
                  </div>
                  <div style="font-size: 14px">
                    {{ cardForm.position ? cardForm.position : "职位" }}
                  </div>
                  <div style="font-size: 12px" class="grey">
                    {{ cardForm.company ? cardForm.company : "公司" }}
                  </div>
                </div>
                <!-- <image  :src="cardForm.headPic" mode=""></image> -->
                <el-image class="teacherHead" :src="cardForm.headPic"></el-image>
              </div>
              <div class="" style="padding: 10px">
                <div class="blue">{{ cardForm.mobile ? cardForm.mobile : "手机号" }}</div>
                <div class="grey">{{ cardForm.email ? cardForm.email : "邮箱" }}</div>
                <div class="grey">{{ cardForm.address ? cardForm.address : "地址" }}</div>
              </div>
              <div class="line"></div>
              <div class="flex flexBetween">
                <!-- <div class="flex flexCenter flexColumn">
                      <div class="iconfont icon-qr-code menuIcon"></div>
                      <div class="menuText">名片二维码</div>
                    </div>
                    <div class="flex flexCenter flexColumn">
                      <div class="iconfont icon-wechat-2 menuIcon"></div>
                      <div class="menuText">TA的微信</div>
                    </div>
                    <div class="flex flexCenter flexColumn">
                      <div class="iconfont icon-fenxiang menuIcon"></div>
                      <div class="menuText">分享名片</div>
                    </div>
                    <div class="flex flexCenter flexColumn">
                      <div class="iconfont icon-app menuIcon"></div>
                      <div class="menuText">学习APP</div>
                    </div> -->
                <img
                  src="../../../static/image/miniAppTab.png"
                  style="width: 350px"
                  alt=""
                />
              </div>
            </div>
            <div class="card">
              <div class="">个人简介</div>
              <div class="grey" style="margin-top: 10px">
                <div v-html="personIntroduce"></div>
              </div>
            </div>
            <div class="card">
              <div class="">公司简介</div>
              <div class="grey" style="margin-top: 10px">
                <div v-html="companyIntroduce"></div>
              </div>
            </div>
          </div>
          <div style="margin-left: 20px">
            <el-card class="box-card">
              <div class="cardTitle">
                对外公开信息<el-button
                  v-auth="'miniApp_saveCardInfo'"
                  style="float: right"
                  type="primary"
                  size="mini"
                  @click="saveCardInfo"
                  >保存</el-button
                >
                
              </div>
              <div style="margin-top: 10px">
                <el-button-group>
                  <el-button type="primary" size="small" plain @click="toAnchor(0)"
                    >基本信息</el-button
                  >
                  <el-button type="primary" size="small" plain @click="toAnchor(1)"
                    >个人简介</el-button
                  >
                  <el-button type="primary" size="small" plain @click="toAnchor(2)"
                    >公司简介</el-button
                  >
                </el-button-group>
                <el-button style="margin-left:5px;" type="primary" size="mini" @click="qrCodesubmit">
                  生成二维码
                </el-button>
              </div>
            </el-card>
            <el-card class="box-card" style="height: 600px; overflow-y: scroll">
              <div class="cardTitle anchor">基本信息</div>
              <div style="margin-top: 10px">
                <el-form
                  ref="cardForm"
                  :model="cardForm"
                  label-width="80px"
                  :rules="cardFormRules"
                >
                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="头像" prop="headPic">
                        <el-upload
                          :headers="upLoadData"
                          class="icoPic-uploader"
                          :action="fileAction"
                          :show-file-list="false"
                          list-type="picture"
                          :on-success="handleIcoPicSuccess"
                          :before-upload="beforeIcoPicUpload"
                        >
                          <img
                            v-if="cardForm.headPic"
                            :src="cardForm.headPic"
                            class="teacherHead"
                          />
                          <i v-else class="el-icon-plus"></i>
                        </el-upload>
                        <div class="content-texts">
                          <span class="content-texts grey"
                            >建议：上传尺寸为750*750的PNG、JPG图片，大小不超过1M</span
                          >
                        </div>
                      </el-form-item>
                     <el-form-item label-width="82px" label="微信二维码" prop="qrcode">
                        <el-upload
                          :headers="upLoadData"
                           class="icoPic-uploader"
                          :action="fileAction"
                          :show-file-list="false"
                          list-type="picture"
                          :on-success="twohandleIcoPicSuccess"
                          :before-upload="beforeIcoPicUpload"
                        >
                          <img
                            v-if="cardForm.qrcode"
                            :src="cardForm.qrcode"
                            class="teacherHead"
                          />
                          <i v-else class="el-icon-plus"></i>
                        </el-upload>
                     </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="姓名" prop="name">
                        <el-input
                          v-model="cardForm.name"
                          placeholder="请输入姓名"
                          auto-complete="off"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="职位" prop="position">
                        <el-input
                          v-model="cardForm.position"
                          placeholder="请输入职位"
                          auto-complete="off"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="公司" prop="company">
                        <el-input
                          v-model="cardForm.company"
                          placeholder="请输入公司"
                          auto-complete="off"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="手机号" prop="mobile">
                        <el-input
                          v-model="cardForm.mobile"
                          placeholder="请输入手机号"
                          auto-complete="off"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="邮箱" prop="email">
                        <el-input
                          v-model="cardForm.email"
                          placeholder="请输入邮箱"
                          auto-complete="off"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="地址" prop="address">
                        <el-input
                          v-model="cardForm.address"
                          placeholder="请输入地址"
                          auto-complete="off"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :sm="24" :md="24" :lg="16">
                      <el-form-item label="微信号" prop="wechatAccount">
                        <el-input
                          v-model="cardForm.wechatAccount"
                          placeholder="请输入微信号"
                          auto-complete="off"
                          maxlength="20"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="个人简介" prop="personIntroduce">
                    <!-- <div class="cardTitle anchor">个人简介</div> -->
                  <div style="background: #fff" v-if="showUePerson">
                    <UE
                      id="personIntroduce"
                      :value="personIntroduce"
                      ref="personUe"
                      reff="1"
                    ></UE>
                  </div>
                  </el-form-item>
                  <el-form-item label="公司简介" prop="companyIntroduce">
                    <!-- <div class="cardTitle anchor">公司简介</div> -->
                  <div style="background: #fff" v-if="showUeCompany">
                    <UE
                      id="companyIntroduce"
                      :value="companyIntroduce"
                      ref="companyUe"
                      reff="2"
                    ></UE>
                  </div>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我的学员" name="3">
        <el-card v-auth="'miniApp_third'">
          <el-form ref="searchForm" :model="searchForm" label-width="80px">
            <el-row :gutter="20">
              <el-col :sm="24" :md="12" :lg="4">
                <el-input
                  v-model="searchForm.name"
                  placeholder="搜索姓名/手机号"
                  auto-complete="off"
                  clearable
                ></el-input>
              </el-col>
              <el-col :sm="24" :md="6" :lg="6" style="float: right">
                <div style="float: right">
                  <!-- <a class="mainColor" @click="reset">重置</a> -->
                  <el-button
                    type="primary"
                    @click="(studentPage.pageNumber = 1), getStudentLoginInfoPageList()"
                    icon="el-icon-search"
                    >查询</el-button
                  >
                </div>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="12" style="float:right">
                  <div style="float:right">
                    <a class="mainColor" @click="reset">重置</a>
                    <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
                  </div>
                </el-col>
              </el-row>-->
          </el-form>
        </el-card>
        <el-card style="margin-top: 20px" v-auth="'miniApp_third'">
          <el-table
            ref="multipleTable"
            :data="studentPage.rows"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%"
            border
            @selection-change="selectionChange"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
          >
            <el-table-column prop="name" label="学员" show-overflow-tooltip width="200px">
              <template slot-scope="row">
                <div style="display: flex">
                  <img
                    style="width: 45px; height: 45px"
                    :src="
                      row.row.headPic
                        ? row.row.headPic
                        : 'http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15743276279534477403800.png'
                    "
                  />
                  <div style="margin-left: 10px; width: 130px">
                    <!-- <span style="color:rgb(106,224,105)" v-if="row.row.recommend=='1'">{{"[推荐]"}}</span>
                      <span style="color:rgb(106,224,105)" v-if="row.row.hot=='1'">{{"[热门]"}}</span>-->
                    <!-- <span style="color:rgb(77,145,225)">{{row.row.name}}</span> -->
                    <span>{{ row.row.name }}</span>
                    <span style="display: block">
                      <span>{{ row.row.mobile }}</span>
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
                prop="validDay"
                align="center"
                show-overflow-tooltip
                label="意向度"
                width="100px"
              >
                <template slot-scope="row">意向度</template>
              </el-table-column> -->
            <!-- <el-table-column
              prop="area"
              show-overflow-tooltip
              label="所在地区"
            ></el-table-column> -->
            <el-table-column
              prop="createTime"
              show-overflow-tooltip
              label="添加时间"
            ></el-table-column>
            <el-table-column
              prop="currentLoginTime"
              show-overflow-tooltip
              label="最近登录"
            ></el-table-column>
            <el-table-column
              prop="buyGoodsCount"
              show-overflow-tooltip
              label="已购买"
            ></el-table-column>
            <!-- <el-table-column
              prop="remark"
              show-overflow-tooltip
              label="备注"
            ></el-table-column> -->
            <!--              <el-table-column show-overflow-tooltip label="操作" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                  <div class="operationGroup" style="z-index:100">-->
            <!--                    <i class="el-icon-edit icon-style" title="编辑" @click="editGoods(scope.row)"></i>-->
            <!--                  </div>-->
            <!--                </template>-->
            <!--              </el-table-column>-->
          </el-table>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 30, 40]"
            style="margin-top: 20px; text-align: right"
            :total="studentPage.total"
            :page-size="studentPage.pageSize"
            :current-studentPage="studentPage.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-card>
      </el-tab-pane>
      <!-- <el-tab-pane label="预约管理" name="4">4</el-tab-pane> -->
    </el-tabs>
     <el-dialog
    title="扫描二维码"
    :visible.sync="dialogVisible"
    width="40%"
    
    >
    <div style=" position:relative; left:33%; top:10%;">
    <qrcode :value="'https://api.g.68wx.com/qrcode/card?recommendId='+reqData.openId" :options="{ size: 200 }"></qrcode>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from "html2canvas"
import { mapGetters } from "vuex";
import UE from "../conmom/CKEditorMultiply.vue";
import QRCode from "qrcodejs2";
import VueQrcode from '@xkeshi/vue-qrcode';
export default {
  name:'miniApp',
  components: { UE,QRCode, qrcode: VueQrcode},
  data() {
    return {
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      activeName: "2",
      appView: {},
      nowAppId: "",
      nowAppName: "",
      qrcode: "",
      agentAppList: [],
      appSelectVisible: false,
      cardForm: {
        headPic:"",
        name:"",
        position:"",
        email:"",
        address:"",
        company:"",
        mobile:"",
        wechatAccount:"",
        personalProfile:"",
        companyProfile:"",
        qrcode:""
      },
      cardFormRules: {
        headPic: [
            { required: true, message: '请上传头像', trigger: 'blur' },
        ],
          qrcode: [
            { required: true, message: '请上传二维码', trigger: 'blur' },
        ],
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        position:[
          { required: true, message: '请输入职位', trigger: 'blur' }
        ],
        company:[
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        email:[
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        mobile:[
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        address:[
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        wechatAccount:[
          { required: true, message: '请输入微信号', trigger: 'blur' }
        ],
        personIntroduce:[
          { required: true, message: '请填写个人简介', trigger: 'blur' }
        ],
        companyIntroduce:[
          { required: true, message: '请填写公司简介', trigger: 'blur' }
        ]
      },
      personIntroduce: "",
      showUePerson: true,
      companyIntroduce: "",
      showUeCompany: true,
      studentPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      searchForm: {
        name: "",
      },
      ids: [],
      loading: false,
      openId:'',
      dialogVisible :false
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
    upLoadData() {
      return {
        openId: this.$store.state.loginData.openId,
        token: this.$store.state.loginData.token,
        LoginType: "agent",
      };
    },
  },
  methods: {
    qrCodesubmit(){
    for (let key in this.cardForm) {
      if(this.cardForm[key] == ""){
        this.dialogVisible = false
        return this.$message.warning('请填写完整后生成二维码')     
      }else{
        this.dialogVisible = true
      } 
    }
    },
    getAgentAppList() {
      this.api.agentApp
        .getAgentAppList({type:2})
        .then((result) => {
          this.loading = false;
          if (result.success) {
            this.agentAppList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // agentAppChange(val) {
    //   this.nowAppId = val;
    //   this.agentAppList.forEach(item => {
    //     if(item.id==val){
    //       this.nowAppName=item.name;
    //     }
    //   });
    //   this.getPageWidgetRelationList();
    // },
    confirmChooseAPP() {
      this.api.schoolPage
        .addOrUpdateCardInfo({ agentAppId: this.nowAppId })
        .then((result) => {
          if (result.success) {
            this.agentAppList.forEach((item) => {
              if (item.id == this.nowAppId) {
                this.nowAppName = item.name;
              }
            });
            this.getPageWidgetRelationList();
            this.appSelectVisible = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveCardInfo() {
      this.$refs.cardForm.validate(val =>{
        if(!val) return this.$message.warning('表单校验不通过,请填写完整后保存。')
     
      this.cardForm.personalProfile = this.$refs.personUe._data.content;
      this.cardForm.companyProfile = this.$refs.companyUe._data.content;
      this.api.schoolPage
        .addOrUpdateCardInfo({...this.cardForm,})
        .then((result) => {
          if (result.success) {
            this.getCardInfo();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
         })
    },
    // getPageWidgetRelationList() {
    //   this.loading = true;
    //   this.api.pageWidgetRelation
    //     .getPageWidgetRelationList({ pageType: 1, agentAppId: this.nowAppId })
    //     .then((result) => {
    //       this.loading = false;
    //       if (result.success) {
    //         if (result.data == null) {
    //           this.appView = {
    //             pageWidgetRelationDTOList: [
    //               {
    //                 name: "",
    //                 type: "",
    //                 list: [],
    //               },
    //             ],
    //           };
    //         } else {
    //           this.appView = result.data;
    //         }
    //         console.log(this.appView);
    //       } else {
    //         this.$message.error(result.message);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    getMiniAppQrCode() {
      let loading = this.$loading.service({
        text: "请稍等",
      });
      this.api.schoolPage
        .getMiniAppQrCode({})
        .then((result) => {
          if (result.success) {
            this.qrcode = result.data;
          } else {
            this.$message.error(result.message);
          }
          loading.close();
        })
        .catch((error) => {
          console.log(error);
          loading.close();
        });
    },
    downloadCode() {
      if (this.qrcode) {
        window.open(this.qrcode);
      } else {
        this.$message.error("请先生成小程序码!");
      }
    },

    handleIcoPicSuccess(res, file) {
      this.cardForm.headPic = file.response.data;
      console.log(file);
      console.log(this.cardForm);
    },
    twohandleIcoPicSuccess(res,file){
    this.cardForm.qrcode = file.response.data
    console.log(this.qrcode);
    },

    beforeIcoPicUpload(file) {
      // const isJPG = file.type === "image";
      const isLt2M = file.size / 1024 / 1024 < 1;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    toAnchor(index) {
      let jump = document.querySelectorAll(".anchor");
      jump[index].scrollIntoView({ block: "start", behavior: "smooth" });
    },
    getCardInfoAppAndQrCode() {
      this.api.schoolPage
        .getCardInfoAppAndQrCode({})
        .then((result) => {
          if (result.success) {
            let data = result.data;
            if (data) {
              this.nowAppId = data.agentAppId;
              this.nowAppName = data.agentAppName;
              this.qrcode = data.qrcode;
              this.getPageWidgetRelationList();
            } else {
              this.nowAppName = "未选择";
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCardInfo() {
      this.showUePerson = false;
      this.showUeCompany = false;
      this.api.schoolPage
        .getCardInfo({})
        .then((result) => {
          if (result.success) {
            console.log(result);
            if(result.data !== null){
            this.cardForm = result.data;
            }else{
              this.cardForm
            }
            this.personIntroduce = this.cardForm.personalProfile;
            this.companyIntroduce = this.cardForm.companyProfile;
            this.showUePerson = true;
            this.showUeCompany = true;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.studentPage.pageSize = pageSize;
      this.getStudentLoginInfoPageList();
    },
    currentChange(pageNumber) {
      this.studentPage.pageNumber = pageNumber;
      this.getStudentLoginInfoPageList();
    },
    getStudentLoginInfoPageList() {
      this.loading = true;
      this.searchForm.pageSize = this.studentPage.pageSize;
      this.searchForm.pageNumber = this.studentPage.pageNumber;
      this.api.schoolPage
        .studentLoginInfoPageList(this.searchForm)
        .then((result) => {
          this.studentPage.rows = result.data.records;
          this.studentPage.total = result.data.total;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectionChange(val) {
      this.ids = [];
      this.multipleSelection = val;
      val.map((e) => this.ids.push(e.id));
    },
  },
  watch: {
    activeName(val) {
      if (val == "1") {
        this.getAgentAppList();
        this.getCardInfoAppAndQrCode();
      }
      if (val == "2") {
        this.getCardInfo();
      }
      if (val == "3") {
        this.getStudentLoginInfoPageList();
      }
    },
  },
  mounted() {
    this.getCardInfo()
    this.getAgentAppList();
    this.getCardInfoAppAndQrCode();
    // this.getStudentLoginInfoPageList();
  },
};
</script>
<style lang="less">
.miniApp {
  .app-view-top {
    width: 375px;
    min-width: 375px;
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    height: calc(100% - 0px);
    justify-content: center;
    .app-view {
      margin-top: 20px;
      width: 375px;
      .view-operation {
        padding: 10px;
        .view-operation-text {
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
          font-weight: bold;
        }
        .view-operation-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          img {
            margin-bottom: 15px;
            border-radius: 10px;
          }
        }
        .chunk-delete {
          display: none;
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          color: rgba(255, 85, 85, 1);
          font-weight: bold;
          cursor: pointer;
        }
      }
      .view-operation:hover {
        .chunk-delete {
          display: inline-block;
          z-index: 2000;
        }
      }
      .view-toolbar {
        display: flex;
        flex-wrap: wrap;
        .view-toolbar-item {
          padding: 10px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .view-toolbar-item-text {
            font-size: 14px;
            margin-top: 6px;
          }
        }
        .chunk-delete {
          display: none;
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          color: rgba(255, 85, 85, 1);
          font-weight: bold;
          cursor: pointer;
        }
      }
      .view-toolbar:hover {
        .chunk-delete {
          display: inline-block;
          z-index: 2000;
        }
      }
      .menuBg {
        width: 100%;
        height: 170px;
        margin-top: -6px;
        /*background-color: #266ef6;*/
        background: -webkit-linear-gradient(#266ef6, #f1f5f8);
        /* Safari 5.1-6.0 */
        background: -o-linear-gradient(#266ef6, #f1f5f8);
        /* Opera 11.1-12.0 */
        background: -moz-linear-gradient(#266ef6, #f1f5f8);
        /* Firefox 3.6-15 */
        background: linear-gradient(#266ef6, #f1f5f8);
        /* 标准语法*/

        img {
          border-radius: 6px;
        }
        .chunk-delete {
          display: none;
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          color: rgba(255, 85, 85, 1);
          font-weight: bold;
          cursor: pointer;
        }
        .chunk-showtext {
          position: absolute;
          right: -100px;
          top: 10px;
          z-index: 2000;
          background: #fff;
          font-size: 14px;
          color: #333;
          padding: 4px 10px;
        }
      }
      .menuBg:hover {
        .chunk-delete {
          display: inline-block;
          z-index: 2000;
        }
      }
    }
  }
  .miniAppCodeImg {
    width: 300px;
    height: 300px;
    border: 1px solid #eee;
    margin: 0 auto;
    color: #97979f;
    line-height: 300px;
    cursor: pointer;
  }
  .teacherHead {
    width: 80px;
    height: 80px;
    border-radius: 10px;
  }
  // .menuIcon {
  //   // font-size: 50px;
  // }
  .menuText {
    // font-size: 20px;
    margin-top: 8px;
  }
  .grey {
    color: #bcbdc2;
  }
  .blue {
    color: #266ef6;
  }
  .line {
    border-bottom: 1px solid #eee;
  }
  .card {
    background-color: #fff;
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
  }
  .flex {
    display: flex;
  }
  .flexCenter {
    align-items: center;
  }
  .flexBetween {
    justify-content: space-between;
  }
  .flexAround {
    justify-content: space-around;
  }
  .flexColumn {
    flex-direction: column;
  }
  .cardTitle {
    font-weight: bold;
    font-size: 14px;
  }
  .box-card {
    width: 600px;
  }
  .el-dialog__body{
   height: 300px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cardSetting/index.vue